const BOOTSTRAP_OPTIONS = { timeout: 1500, retries: 2 }
export default BOOTSTRAP_OPTIONS
